export default __webpack_public_path__ + "static/media/left_big.1ce5fb49.svg";